import { useCurrency } from '@/hooks/useCurrency'
import { useTranslation } from 'react-i18next'
import { GlobeHemisphereWestIcon, WalletIcon, HardDrivesIcon } from '@phosphor-icons/react'
import type { Icon } from '@phosphor-icons/react'

interface Stat {
  icon: Icon
  value: string | number
  label: string
}

interface StatsGridProps {
  stats: Stat[]
  className?: string
}

function StatsGrid({ stats, className = '' }: StatsGridProps) {
  return (
    <div className={`flex flex-nowrap justify-center gap-2 sm:gap-6 md:gap-12 max-w-3xl mx-auto ${className}`}>
      {stats.map((stat, index) => (
        <div
          key={index}
          className="flex items-center gap-2 sm:gap-4 bg-primary/5 rounded-xl px-2 sm:px-6 py-3 md:px-8 md:py-5 flex-1 min-w-0"
        >
          <stat.icon weight="duotone" className="w-6 h-6 sm:w-10 sm:h-10 md:w-12 md:h-12 flex-shrink-0" style={{ color: 'var(--color-primary)' }} />
          <div className="min-w-0">
            <div className="text-base sm:text-xl md:text-2xl font-bold text-primary leading-tight truncate">{stat.value}</div>
            <div className="text-xs sm:text-sm text-muted-foreground truncate">{stat.label}</div>
          </div>
        </div>
      ))}
    </div>
  )
}

interface HeroStatsProps {
  totalCountries?: number
  minRate?: number
  uptime?: string
}

export function HeroStats({ totalCountries = 195, minRate, uptime = '99.9%' }: HeroStatsProps) {
  const { formatCurrency } = useCurrency()
  const { t } = useTranslation('marketing')

  const stats: Stat[] = [
    {
      icon: GlobeHemisphereWestIcon,
      value: `${totalCountries}+`,
      label: t('hero.stats.countries')
    },
    {
      icon: WalletIcon,
      value: minRate ? formatCurrency(minRate) : '...',
      label: t('hero.stats.startingRate')
    },
    {
      icon: HardDrivesIcon,
      value: uptime,
      label: t('hero.stats.uptime')
    }
  ]

  return <StatsGrid stats={stats} />
}
